import type { printOnDemand } from "common/utils/models";

/**
 * Transform numeric IDs to strings in print on demand product responses
 * This ensures consistent ID types throughout the application
 */
export function transformPrintOnDemandIds(
  response: printOnDemand.getProduct.Response | undefined
): printOnDemand.getProduct.Response | undefined {
  if (!response?.compositions) {
    return response;
  }

  return {
    ...response,
    compositions: response.compositions.map(comp => ({
      ...comp,
      id: String(comp.id),
      variants: comp.variants.map(variant => ({
        ...variant,
        id: String(variant.id),
        sku: variant.sku
      }))
    }))
  };
}
